// document.addEventListener("DOMContentLoaded", function () {
//     var optOutElem = document.getElementById("fwMatomoOptOut");
//     var defaultStrings = {
//         de: {
//             intro: "Sie haben die Möglichkeit zu verhindern, dass von Ihnen hier getätigte Aktionen analysiert und verknüpft werden. Dies wird Ihre Privatsphäre schützen, aber wird auch den Besitzer daran hindern, aus Ihren Aktionen zu lernen und die Bedienbarkeit für Sie und andere Benutzer zu verbessern.",
//             introOptOut: "Opt-out abgeschlossen; Ihre Besuche auf dieser Webseite werden nicht vom Webanalysetool erfasst. Bitte beachten Sie, dass auch der Matomo-Deaktivierungs-Cookie dieser Webseite gelöscht wird, wenn Sie die in Ihrem Browser abgelegten Cookies entfernen. Außerdem müssen Sie, wenn Sie einen anderen Computer oder einen anderen Webbrowser verwenden, die Deaktivierungsprozedur nochmals absolvieren.",
//             label: "Ihr Besuch dieser Webseite wird aktuell von Matomo erfasst. Hier klicken um die Zustimmung zu wiederrufen.",
//             labelOptOut: "Ihr Besuch dieser Webseite wird aktuell von Matomo NICHT erfasst. Hier klicken um der Datenerfassung zuzustimmen.",
//         },
//         en: {
//             intro: "You may choose to prevent this website from aggregating and analyzing the actions you take here. Doing so will protect your privacy, but will also prevent the owner from learning from your actions and creating a better experience for you and other users.",
//             introOptOut: "Opt-out complete; your visits to this website will not be recorded by the Web Analytics tool. Note that if you clear your cookies, delete the opt-out cookie, or if you change computers or Web browsers, you will need to perform the opt-out procedure again.",
//             label: "You are currently opted in. Click here to opt out.",
//             labelOptOut: "You are currently opted out. Click here to opt in.",
//         },
//     };

//     // get current language from html attribute and check if translated
//     var htmllang = document.documentElement.lang.toLowerCase();
//     var isSupportedLanguage = Object.keys(defaultStrings).indexOf(htmllang) !== -1;
//     var lang = isSupportedLanguage ? htmllang : "en";

//     // check if custom strings exist
//     var customStrings = {
//         intro: optOutElem && optOutElem.querySelector(".intro") ? optOutElem.querySelector(".intro").innerText : undefined,
//         introOptOut: optOutElem && optOutElem.querySelector(".introOptOut") ? optOutElem.querySelector(".introOptOut").innerText : undefined,
//         label: optOutElem && optOutElem.querySelector(".label") ? optOutElem.querySelector(".label").innerText : undefined,
//         labelOptOut: optOutElem && optOutElem.querySelector(".labelOptOut") ? optOutElem.querySelector(".labelOptOut").innerText : undefined,
//     };
//     var strings = {
//         intro: customStrings.intro || defaultStrings[lang].intro,
//         introOptOut: customStrings.introOptOut || defaultStrings[lang].introOptOut,
//         label: customStrings.label || defaultStrings[lang].label,
//         labelOptOut: customStrings.labelOptOut || defaultStrings[lang].labelOptOut,
//     };

//     function setOptOutText(elem) {
//         var inputElem = elem.querySelector("input");
//         var introElem = elem.querySelector(".intro");
//         var labelStrongElem = elem.querySelector("label > strong");

//         // replace text based on status
//         _paq.push([
//             function () {
//                 if (this.isUserOptedOut()) {
//                     inputElem.checked = false;
//                     labelStrongElem.innerText = strings.labelOptOut;
//                     if (introElem) {
//                         introElem.innerText = strings.introOptOut;
//                     }
//                 } else {
//                     inputElem.checked = true;
//                     labelStrongElem.innerText = strings.label;
//                     if (introElem) {
//                         introElem.innerText = strings.intro;
//                     }
//                 }
//             },
//         ]);
//     }

//     function createOptOut(elem) {
//         var inputElem = elem.querySelector("input");
//         var labelElem = elem.querySelector("label");
//         var labelStrongElem = elem.querySelector("label > strong");
//         var introElem = elem.querySelector(".intro");
//         var disableIntro = elem.classList.contains("disableintro");

//         // remove hidden elements from page
//         elem.querySelectorAll("div[hidden]").forEach((hiddenelem) => {
//             hiddenelem.remove();
//         });

//         // create elems if they dont exist
//         if (!introElem && !disableIntro) {
//             var newIntroElem = document.createElement("div");
//             newIntroElem.classList.add("intro");
//             newIntroElem.innerText = strings.intro;
//             introElem = newIntroElem;
//             elem.appendChild(newIntroElem);
//         }

//         if (!inputElem) {
//             var newInputElem = document.createElement("input");
//             inputElem = newInputElem;
//             elem.appendChild(newInputElem);
//         }

//         if (!labelElem) {
//             var newLabelElem = document.createElement("label");
//             labelElem = newLabelElem;
//             elem.appendChild(newLabelElem);
//         }

//         if (!labelStrongElem) {
//             var newLabelStrongElem = document.createElement("strong");
//             labelStrongElem = newLabelStrongElem;
//             labelElem.appendChild(newLabelStrongElem);
//         }

//         // fill contents
//         inputElem.id = "matomooptout";
//         inputElem.type = "checkbox";
//         labelElem.htmlFor = "matomooptout";
//         labelStrongElem.innerText = strings.label;

//         // set/replace initial text
//         setOptOutText(elem);

//         // add click event listener
//         inputElem.addEventListener("click", function () {
//             // set matomo optout
//             if (inputElem.checked) {
//                 _paq.push(["forgetUserOptOut"]);
//             } else {
//                 _paq.push(["optUserOut"]);
//             }

//             // refresh text
//             setOptOutText(elem);
//         });
//     }

//     // check if optoutelem exist and fill if true
//     if (optOutElem) {
//         createOptOut(optOutElem);
//     }
// });

class MatomoOptOut extends HTMLElement {
    #isOptedOut;

    #currentLang;
    #langStrings;
    #defaultStrings;

    constructor() {
        super();

        this.#currentLang = "de";
        this.#defaultStrings = {
            de: {
                intro: "Sie haben die Möglichkeit zu verhindern, dass von Ihnen hier getätigte Aktionen analysiert und verknüpft werden. Dies wird Ihre Privatsphäre schützen, aber wird auch den Besitzer daran hindern, aus Ihren Aktionen zu lernen und die Bedienbarkeit für Sie und andere Benutzer zu verbessern.",
                introOptOut: "Opt-out abgeschlossen; Ihre Besuche auf dieser Webseite werden nicht vom Webanalysetool erfasst. Bitte beachten Sie, dass auch der Matomo-Deaktivierungs-Cookie dieser Webseite gelöscht wird, wenn Sie die in Ihrem Browser abgelegten Cookies entfernen. Außerdem müssen Sie, wenn Sie einen anderen Computer oder einen anderen Webbrowser verwenden, die Deaktivierungsprozedur nochmals absolvieren.",
                label: "Ihr Besuch dieser Webseite wird aktuell von Matomo erfasst. Hier klicken um die Zustimmung zu wiederrufen.",
                labelOptOut: "Ihr Besuch dieser Webseite wird aktuell von Matomo NICHT erfasst. Hier klicken um der Datenerfassung zuzustimmen.",
            },
            en: {
                intro: "You may choose to prevent this website from aggregating and analyzing the actions you take here. Doing so will protect your privacy, but will also prevent the owner from learning from your actions and creating a better experience for you and other users.",
                introOptOut: "Opt-out complete; your visits to this website will not be recorded by the Web Analytics tool. Note that if you clear your cookies, delete the opt-out cookie, or if you change computers or Web browsers, you will need to perform the opt-out procedure again.",
                label: "You are currently opted in. Click here to opt out.",
                labelOptOut: "You are currently opted out. Click here to opt in.",
            },
        };
    }

    connectedCallback() {
        // get strings based on current language
        this.#currentLang = "de";
        const isSupportedLanguage = Object.keys(this.#defaultStrings).indexOf(this.#currentLang) !== -1;
        const lang = isSupportedLanguage ? this.#currentLang : "en";

        // get current opt out status
        this.#isOptedOut = false;
        window._paq.push([
            function () {
                this.#isOptedOut = this.isUserOptedOut();
            },
        ]);

        // TODO: check if custom strings exist
        const customStrings = {
            intro: undefined,
            introOptOut: undefined,
            label: undefined,
            labelOptOut: undefined,
        };

        // get strings based on current language or use custom strings
        const strings = {
            intro: customStrings.intro || this.#defaultStrings[lang].intro,
            introOptOut: customStrings.introOptOut || this.#defaultStrings[lang].introOptOut,
            label: customStrings.label || this.#defaultStrings[lang].label,
            labelOptOut: customStrings.labelOptOut || this.#defaultStrings[lang].labelOptOut,
        };

        // set strings
        this.#langStrings = strings;

        // render
        this.render();
        this.addEventListeners();
    }

    render() {
        this.innerHTML = `
            <div class="fw-matomo-optout-inner">
                <div class="fw-matomo-optout-intro">${this.#langStrings.intro}</div>
                <input class="fw-matomo-optout-checkbox" type="checkbox">
                <label class="fw-matomo-optout-label">
                    <strong>${this.#isOptedOut ? this.#langStrings.label : this.#langStrings.labelOptOut}</strong>
                </label>
            </div>
        `;
    }

    addEventListeners() {
        const inputElem = this.querySelector("input");
        inputElem.addEventListener("click", (e) => this.sendOptOutEvent(e));
    }

    sendOptOutEvent(event) {
        if (event.target.checked) {
            window._paq.push(["forgetUserOptOut"]);
            this.#isOptedOut = false;
        } else {
            window._paq.push(["optUserOut"]);
            this.#isOptedOut = true;
        }

        this.render();
    }
}

customElements.define('fw-matomo-optout', MatomoOptOut);